<template>
  <v-row no-gutters>
    <v-col class='white--text'>

      <v-menu open-on-click bottom offset-y rounded='lg' transition="scale-transition"
              v-if='basketQuantity > 0'>
        <template v-slot:activator='{ on, attrs }'>
          <div v-bind='attrs' v-on='on' class="basket">
            <v-badge
              color='light-blue darken-1'
              v-if='basketQuantity > 0'
              :content='basketQuantity'
            >
              <span><v-icon color='white'>mdi-cart-minus</v-icon></span>
            </v-badge>
            <span>{{ basketTotalPrice.toFixed(2) }} {{ text.common.currency }}</span></div>

        </template>

        <v-list dense>
          <v-list-item
            v-for='(item, index) in firstBasketItems'
            :key='index'
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.title" class="listItem"/>
              <v-list-item-subtitle
                v-text="item.quantity + ' ' +  text.common.pcs + ' '  +
                  item.totalPrice + ' ' + text.common.currency"/>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if='basketPositions > 4'>...</v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col cols='12' class='text-sm-right'>
                  {{ basketTotalPrice }} {{ text.common.currency }}
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-row align-content='space-between'>
                <v-col cols='6' class='text-sm-left'>
                  <v-btn x-small color='error' text @click="openDialog = true">
                    {{ text.common.clearBasket }}
                  </v-btn>
                </v-col>
                <v-col cols='6' class='text-sm-right'>
                  <v-btn x-small color='primary' dark @click="$router.push('/cart')">
                    {{ text.common.toBasket }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <template v-else>
        <span><v-icon color='white'>mdi-cart-minus</v-icon></span>
        <span>{{ basketTotalPrice.toFixed(2) }} {{ text.common.currency }}</span>
      </template>
    </v-col>
    <DialogContainer :open="openDialog" v-on:cancel="cancel"
                     v-on:confirm="clearBasket">{{ text.pages.cart.clear }}
    </DialogContainer>
  </v-row>
</template>

<script>
import Basket from '@/core/Basket';
import { translations } from '@/lang/translations';
import DialogContainer from '../DialogContainer.vue';

export default {
  name: 'Cart',
  components: {
    DialogContainer,
  },
  data() {
    return {
      text: translations.pl,
      basketPositions: 0,
      basketCounter: 4,
      openDialog: false,
      basket: new Basket(),
      firstBasketItems: [],
    };
  },
  computed: {
    basketQuantity() {
      return this.$store.state.basketQuantity;
    },
    basketTotalPrice() {
      return this.$store.state.basketTotalPrice;
    },
  },
  mounted() {
    this.firstBasketItems = this.getFirstBasektElements();
  },
  watch: {
    basketQuantity() {
      this.firstBasketItems = this.getFirstBasektElements();
    },
  },
  methods: {
    getFirstBasektElements() {
      const { basket } = this.$store.state;
      const basketValues = Object.values(basket);
      const items = [];
      let i;
      this.basketPositions = basketValues.length;

      for (i = 0; i < this.basketCounter; i += 1) {
        if (basketValues[i]) {
          items.push({
            title: basketValues[i].name,
            quantity: basketValues[i].quantity,
            totalPrice: basketValues[i].quantity * basketValues[i].price,
          });
        }
      }
      return items;
    },
    cancel() {
      this.openDialog = false;
    },
    clearBasket() {
      this.openDialog = false;
      this.basket.clearBasket();
    },
  },
};
</script>
<style scoped>
.listItem {
  width: 80%;
}

.basket {
  padding: 0;
}

.basket p {
  margin-bottom: 0;
}
</style>
